/* eslint-disable no-useless-escape */
// update font size of root when window resize
export function setHtmlFont() {
  const docEl = document.documentElement;
  const dpr = window.devicePixelRatio || 1;

  // adjust body font size
  function setBodyFontSize() {
    if (document.body) {
      document.body.style.fontSize = `${16 * dpr}px`;
    } else {
      document.addEventListener('DOMContentLoaded', setBodyFontSize);
    }
  }
  setBodyFontSize();

  function setRemUnit() {
    let rem = 16;
    rem = (docEl.offsetWidth / 750) * 100;
    docEl.style.fontSize = `${rem}px`;
  }
  setRemUnit();
  // reset rem unit on page resize
  window.addEventListener('resize', setRemUnit);
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      setRemUnit();
    }
  });
}

// 开始时间-结束时间
export const dateYear = (start, end) => {
  var datestart = new Date(forMatDate(start));
  var datend = new Date(forMatDate(end));
  // var y = datestart.getFullYear();
  var m = datestart.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = datestart.getDate();
  d = d < 10 ? '0' + d : d;

  // var yend = datend.getFullYear();
  var mend = datend.getMonth() + 1;
  // mend = mend < 10 ? '0' + mend : mend;
  var dend = datend.getDate();
  // dend = dend < 10 ? '0' + dend : dend;
  var time = m + '月' + d + '日' + '-' + mend + '月' + dend + '日';
  return time;
};

// 处理ios日期NAN 问题
export const forMatDate = (time) => {
  let dateStr = time.replace(/\-/g, '/'); // 将'-'符号替换成'/'
  let dataTime = new Date(dateStr).getTime();
  return dataTime;
};

// 截取url中的userInfo
export function getQueryVariable(variable) {
  let hash = window.location.hash.substring(1);
  const query = hash.split('?');
  if (!query[1]) {
    return '';
  }
  let vars = query[1].split('&');
  for (let obj of vars) {
    let pair = obj.split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return '';
}